import { Link } from "react-router-dom";

interface InvoiceCustomerNoticeProps {
  customerName: string | null;
  customerId: string | null;
  isMainCustomer: boolean;
  notInPowerOffice: boolean;
}

/**
 * VIB-3030: forklaring når fakturaen går til en annen kunde enn hovedkunden,
 * og stopp når den kunden ikke finnes i PowerOffice ennå.
 */
export function InvoiceCustomerNotice({ customerName, customerId, isMainCustomer, notInPowerOffice }: InvoiceCustomerNoticeProps) {
  if (isMainCustomer || !customerName) return null;
  if (notInPowerOffice) {
    return (
      <div role="alert" className="rounded-lg border-[1.5px] border-destructive/40 bg-destructive/5 p-3 text-sm space-y-1">
        <p className="font-semibold text-destructive">Kunden finnes ikke i PowerOffice ennå.</p>
        <p>
          Fakturaen kan ikke opprettes før {customerName} er koblet. Åpne kundekortet og velg «Koble til
          PowerOffice», og kom tilbake hit.{" "}
          {customerId && (
            <Link to={`/kunde/${customerId}`} target="_blank" className="font-medium text-primary hover:underline">
              Åpne kundekortet
            </Link>
          )}
        </p>
      </div>
    );
  }
  return (
    <div className="rounded-lg border-[1.5px] border-primary/25 bg-primary/5 p-3 text-sm space-y-0.5">
      <p className="font-semibold">Fakturaen går til {customerName}, ikke hovedkunden.</p>
      <p className="text-muted-foreground">
        Referanser og e-post er hentet fra kundekortet deres. Prosjektets egne referanser gjelder bare hovedkunden.
      </p>
    </div>
  );
}
